import { post, type RequestOptions } from "~/common/request"

export const getCurrentUser = () => {
  return post<API.User.SessionUser>("/api/user/me", undefined, {
    notify: false,
  })
}

export const getUserBehavior = () => {
  return post<Partial<API.User.UserBehavior>>("/api/user/behavior", undefined, {
    notify: false,
  })
}

export const sendLoginCode = (
  params: API.User.GetVerifyCodeParams,
  options?: RequestOptions,
) => {
  return post<null>("/api/user/login_code", params, options)
}

export const verifyLoginCode = (
  params: API.User.VerifyCodeParams,
  options?: RequestOptions,
) => {
  return post<API.User.SessionUser>("/api/user/login_verify", params, options)
}

export const loginWithXqt = (params: API.User.XqtLoginParams) => {
  return post<API.User.SessionUser>("/api/user/xqt_login", params)
}

export const logoutUser = (options?: RequestOptions) => {
  return post<null>("/api/user/logout", undefined, options)
}

export const listUserOrders = (
  params: API.User.UserOrderListParams = {},
  signal?: AbortSignal,
) => {
  return post<API.User.UserOrderListResponse>("/api/user/orders", params, {
    signal,
  })
}

export const getWalletBalanceSummary = (signal?: AbortSignal) => {
  return post<API.User.WalletBalanceSummaryResponse>(
    "/api/user/wallet_balance_summary",
    undefined,
    { signal },
  )
}

export const listWalletRecords = (
  params: API.User.WalletRecordListParams,
  signal?: AbortSignal,
) => {
  return post<API.User.WalletRecordListResponse>(
    "/api/user/wallet_records",
    params,
    { signal },
  )
}
